module.exports = __webpack_public_path__ + "e45d81ae9864865e1ab4a3aae1d18d32.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/labels/all.svg
// module id = HKJx
// module chunks = 0